import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

/**
 * Bridges the home "ບັດ QR" quick action to the global QR modal host
 * (QrButtonComponent). The floating QR button was removed; the policy-QR
 * selector is now opened on demand by emitting on `open$`.
 */
@Injectable({ providedIn: 'root' })
export class QrService {
  private readonly _open$ = new Subject<void>();

  /** Emits whenever something requests the policy-QR selector to open. */
  readonly open$: Observable<void> = this._open$.asObservable();

  /** Request the QR selector modal to open. */
  open(): void {
    this._open$.next();
  }
}
